// Identique à jminterim-dashboard (src/components/Candidat/data/arretMaladieTypes.js)
export const arretMaladieTypes = [
  { value: 'maladie', label: 'Maladie' },
  { value: 'accident', label: 'Accident' },
  { value: 'maternite', label: 'Maternité' },
  { value: 'paternite', label: 'Paternité' },
  { value: 'autres', label: 'Autres' },
]
